import React from 'react';

function Footer() {
  return (
    <footer style={footerStyle}>
      <p>© Legal Experts India 2026</p>
      
  
        <p>Developed By- Amit Gaur | gauramitk@gmail.com</p>

<ul>
        <div class="social-icons ">
        
        <a href='https://facebook.com/' class ="Facebook" data-tittle ="facebook" target='_blank'></a>
      
    </div>
      
    </ul>
     
    </footer>
  );
}

// Styling the footer directly in the component (you can also use a separate CSS file)
const footerStyle = {
  backgroundColor: '#335',
  color: 'white',
  textAlign: 'center',
  padding: '1px',
  position: 'relative',
  bottom: '0',
  width: '100%',
 
};

export default Footer;